import { createClient } from '@/lib/contentful/initContentful';
import { MENU_TAXONOMY_COOKING, MENU_TAXONOMY_NONE_COOKING } from '@/constants/app';
import { IMenu } from '@/@types/generated/contentful';

const client = createClient();

export async function fetchMenusEntries() {
  let menuList: IMenu[] = [];
  await client
    .getEntries({
      content_type: 'menu',
      order: 'fields.id'
    })
    .then((doc) => {
      menuList = (doc.items as IMenu[]).filter((item) => item);
    })
    .catch((error) => {
      throw new Error(error);
    });
  return menuList;
}

export async function fetchNewMenusEntries(limit: number) {
  const menuList: IMenu[] = [];
  const menuType = [MENU_TAXONOMY_COOKING, MENU_TAXONOMY_NONE_COOKING];
  await Promise.all(
    menuType.map(async (type) => {
      await client
        .getEntries({
          content_type: 'menu',
          'fields.type': type,
          order: '-fields.id',
          limit: limit || 7
        })
        .then((doc) => {
          (doc.items as IMenu[]).map((item) => menuList.push(item));
        })
        .catch((error) => {
          throw new Error(error);
        });
    })
  );
  return menuList;
}

export async function fetchFeatureMenusEntries(features: string[]) {
  let menuList: IMenu[] = [];
  await client
    .getEntries({
      content_type: 'menu',
      'fields.feature': features,
      order: 'fields.id'
    })
    .then((doc) => {
      menuList = (doc.items as IMenu[]).filter((item) => item);
    })
    .catch((error) => {
      throw new Error(error);
    });
  return menuList;
}

export async function fetchTaxonomyMenusEntries(taxonomy: string) {
  let menuList: IMenu[] = [];
  await client
    .getEntries({
      content_type: 'menu',
      'fields.taxonomy': taxonomy,
      order: 'fields.id'
    })
    .then((doc) => {
      menuList = (doc.items as IMenu[]).filter((item) => item);
    })
    .catch((error) => {
      throw new Error(error);
    });
  return menuList;
}

export async function fetchSameCategoryMenusEntries({
  menuCat,
  menuId
}: {
  menuCat: string;
  menuId: string;
}) {
  let menuList: IMenu[] = [];
  await client
    .getEntries({
      content_type: 'menu',
      'fields.cat': menuCat,
      order: 'fields.id'
    })
    .then((doc) => {
      menuList = (doc.items as IMenu[]).filter((el) => el.fields.id !== menuId);
    })
    .catch((error) => {
      throw new Error(error);
    });
  return menuList;
}

export async function fetchFavoritedMenusEntries(favoritedList: string[]) {
  const result: IMenu[] = await Promise.all(
    favoritedList.map((item) => {
      return client
        .getEntries({
          content_type: 'menu',
          'fields.id': item,
          order: 'fields.id'
        })
        .then((doc) => {
          return doc.items[0] as IMenu;
        })
        .catch((error) => {
          throw new Error(error);
        });
    })
  );
  const menuList = result.filter((item) => item);
  return menuList;
}

export async function fetchMenuEntry(slug: string) {
  let menu: IMenu | null = null;
  await client
    .getEntries({
      content_type: 'menu',
      'fields.slug': slug
    })
    .then((doc) => {
      menu = doc.items[0] as IMenu;
    })
    .catch((error) => {
      throw new Error(error);
    });
  return menu;
}
